import { useSyncExternalStore } from "react";

const collapsedReviewKeys = new Set<string>();
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function setReviewExpanded(reviewKey: string, isExpanded: boolean): void {
  if (isExpanded) collapsedReviewKeys.delete(reviewKey);
  else collapsedReviewKeys.add(reviewKey);
  listeners.forEach((listener) => listener());
}

function isExpandedOnServer(): boolean {
  return true;
}

export function useLiveReviewExpansion(conversationId: string, messageId: string): [boolean, (isExpanded: boolean) => void] {
  const reviewKey = `${conversationId}:${messageId}`;
  const isExpanded = useSyncExternalStore(subscribe, () => !collapsedReviewKeys.has(reviewKey), isExpandedOnServer);
  return [isExpanded, (nextIsExpanded) => setReviewExpanded(reviewKey, nextIsExpanded)];
}
